import { render, staticRenderFns } from "./PayrollMain.vue?vue&type=template&id=73895157"
import script from "./PayrollMain.vue?vue&type=script&lang=js"
export * from "./PayrollMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports